// #MODULE - ProductThumbnail.
// > Author: Balasubramanian Karthikesan
// > Create Date:
// ##DESCRIPTION: This is the item view to display product thumbnail

import $ from 'jquery';
import Backbone from 'backbone';
import Mn from 'backbone.marionette';
import { createCarouselView, HORIZONTAL, ArrowIconSize } from '@component/carousel';
import tagManager from '@component/common/src/util/TagManagerUtil';
import ProductColorSwatches from '../components/ProductColorSwatches';
import ProductColorSwatch from '../ProductColorSwatch';
import colorSwatchTpl from '../templates/partials/component-product-thumbnail/ColorSwatchTemplate.hbs';


export default Mn.ItemView.extend({
  createSwatchCarousel(swatchHolder, swatches) {
    const collection = new Backbone.Collection(swatches);

    const carouselItems = collection.map(model => new ProductColorSwatch({ model }).render().$el.get(0));
    // TODO: handle childwidth dynamically
    const opts = Object.assign(
      {},
      {
        el: swatchHolder,
        childrenView: carouselItems,
        carouselType: HORIZONTAL,
        arrowIconSize: ArrowIconSize.LARGE,
        childWidth: 35,
      },
      this.options.config,
    );
    if (swatches.swatchImageOptimizationEnabled) {
      opts.newColorSwatchSprite = swatches[0] ? swatches[0].colorSwatchSprite : '';
    }
    const swatchCarousel = createCarouselView(opts.carouselType, opts);
    swatchCarousel.render();

    return swatchCarousel;
  },
  carouselSwatchImage(param) {
    const traits = param;
    const swatches = traits.colors.colorMap || [];
    swatches.swatchImageOptimizationEnabled = traits.swatchImageOptimizationEnabled || '';
    // render color swatch in a carousel if swatches more than 5
    const swatchHolder = `#${this.$el.find('.colorSwatchesContainer').attr('id')}`;
    if (param.showSwatchOptExpEnabled) {
      if (swatches && swatches.length > 5) {
        traits.colors.noCarousel = true;
        if (traits.colors.selectedColor) {
          traits.colors.colorMap = traits.colors.colorMap.sort(color => ((color.id === traits.colors.selectedColor.id) ? 1 : -1))
            .reverse().splice(0, 5);
        } else {
          traits.colors.colorMap = traits.colors.colorMap.splice(0, 5);
        }
        $(swatchHolder).html(colorSwatchTpl(traits));
        $(swatchHolder).addClass('showMoreSwatches');
        if ($(swatchHolder).find('colorSwatches .moreSwatchesLink').length < 1) {
          $(swatchHolder).find('ul.colorSwatches').append(`<li class='moreSwatchesLink'><a><span class='countLgScrn'><span>&plus;</span><span class='remSwatchsLen'>${swatches.length}</span></span><span class='countSmScrn'><span>&plus;</span><span class='remSwatchsLen'>${swatches.length + 1}</span></span></a></li>`);
        }
      } else if (swatches && swatches.length > 1 && swatches.length <= 5) {
        traits.colors.noCarousel = true;
        $(swatchHolder).html(colorSwatchTpl(traits));
      }
    } else if (swatches && swatches.length > 5) {
      this.createSwatchCarousel(swatchHolder, swatches);
      $('.productDescription').addClass('itemDetails');
    } else if (swatches && swatches.length > 1 && swatches.length <= 5) {
      traits.colors.noCarousel = true;
      $(swatchHolder).html(colorSwatchTpl(traits));
    }
    const swatchProductId = this.$el.find('.colorSwatchesContainer').data('colorswatchproduct');
    const swatchSelected = this.$el.find('.colorSwatchesContainer').find('.swatchSelected');
    const jumboSwatchUrl = swatchSelected.data('jumboswatchurl');
    const jumboswatchOffset = swatchSelected.data('jumboswatchoffset');
    if (jumboSwatchUrl && jumboswatchOffset) {
      this.showHideJumboSwatch(swatchProductId, jumboSwatchUrl, jumboswatchOffset, true);
    }
  },
  buildProductColorSwatch(traits, detail, snbTemplateUrlRemovalattrs) {
    // build color swatch
    // products with a single color in the map will not build out swatches
    if (traits && traits.colors && traits.colors.colorMap && (traits.colors.colorMap.length > 1)) {
      this.buildColorSwatch(traits, detail, snbTemplateUrlRemovalattrs);
    }
  },
  buildColorSwatch(data, detail, snbTemplateUrlRemovalattrs) {
    const traits = data;

    traits.colors.colorMap = ProductColorSwatches.buildColorSwatchData(data, detail, snbTemplateUrlRemovalattrs);
    if (this.model) {
      this.model.set('traits', traits);
    }
  },
  swatchSelection(e) {
    const swatchSelection = $(e.currentTarget).children('div');
    let swatchClass = '';
    const swatchProductId = swatchSelection.parents('.colorSwatchesContainer').data('colorswatchproduct');
    let jumboSwatchUrl = swatchSelection.data('jumboswatchurl');
    let jumboswatchOffset = swatchSelection.data('jumboswatchoffset');
    if (!$(e.currentTarget).hasClass('swatchColorsMore')) {
      if (e.type === 'mouseover' && !swatchSelection.hasClass('swatchSelected')) {
        swatchClass = 'swatchHover';
      } else if (e.type === 'click') {
        swatchClass = 'swatchSelected';
        $(`#colorSwatch_${swatchProductId} li > div`).removeClass(swatchClass);
      } else if (e.type === 'mouseout') {
        swatchSelection.removeClass('swatchHover');
        jumboSwatchUrl = this.$el.find('.swatchSelected').data('jumboswatchurl');
        jumboswatchOffset = this.$el.find('.swatchSelected').data('jumboswatchoffset');
      }
      swatchSelection.addClass(swatchClass);
      if (jumboSwatchUrl) {
        this.showHideJumboSwatch(swatchProductId, jumboSwatchUrl, jumboswatchOffset, true);
      } else {
        this.showHideJumboSwatch(swatchProductId, jumboSwatchUrl, jumboswatchOffset, false);
      }
    }
  },
  showHideJumboSwatch(productId, url, offset, visibility) {
    const jumboSwatch = $(`#jumboSwatch_${productId}`);
    if (visibility) {
      jumboSwatch.parent('.jumboSwatch').show();
      jumboSwatch.css('background', `url(${url})${offset}px 0 transparent`);
    } else {
      jumboSwatch.parent('.jumboSwatch').hide();
      jumboSwatch.css('background', '');
    }
  },
  fireTagOnClick(slotId, pId, pageType) {
    const itemPos = (slotId !== undefined && slotId >= 0) ? slotId + 1 : '';
    const eventName = (pageType && pageType.similarProducts) ? 'mlt product click' : 'product click';
    const utagData = {
      event_name: eventName,
      product_id: pId ? [pId.toString()] : [''],
      product_position: [itemPos.toString()],
    };
    tagManager.fireTag('link', utagData);
  },
});
